import { Dispatch, SetStateAction, useState } from "react";
import { Box, Button, TextField, MenuItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import { ENUM_ROUTES } from "../../RoutesEnum";
import countries from "../../helpers/constants/countries.json";
import { isValidInput } from "../../utils/validations";
import useAuth from "../../hooks/useAuth";


type BookingTopBarProps = {
  setDebouncedSearchTerm: Dispatch<SetStateAction<string>>;
  country?: string;
  onChangeCountry?: (value: string) => void;
};

const BookingTopBar = ({
  setDebouncedSearchTerm,
  country = "",
  onChangeCountry,
}: BookingTopBarProps) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const user = useAuth();

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <div className="form flex-3">
            <Box className="search_box">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
            {user?.currentRole !== "SUB_ADMIN" && (
              <TextField
                select
                hiddenLabel
                type="text"
                name="country"
                variant="outlined"
                placeholder="Select country"
                value={country || "__placeholder__"}
                onChange={(e) => onChangeCountry && onChangeCountry(e.target.value)}
              >
                <MenuItem value="__placeholder__" disabled>
                  Select country
                </MenuItem>
                <MenuItem value="">All Countries</MenuItem>
                {(countries as Array<{ name: string; code: string; dialCode: string }>).map((c) => (
                  <MenuItem key={c.code} value={c.name}>
                    {c.name}
                  </MenuItem>
                ))}
              </TextField>
            )}
          </div>
        </div>
        <div className="right_s">
          {/* <Button
            className="btn btn_primary"
            onClick={() => navigate(ENUM_ROUTES.ADD_BOOKING)}
          >
            <AddIcon /> Add
          </Button> */}
          <Button className="btn btn_grey">
            <DownloadIcon /> Export
          </Button>
        </div>
      </div>
    </>
  );
};

export default BookingTopBar;
